import React from 'react';
import * as Yup from 'yup';
import { withFormik, Field } from 'formik';
import { Form, Button } from 'semantic-ui-react';
import { withLocalize } from 'react-localize-redux';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import ReCAPTCHA from 'react-google-recaptcha';
import { HHInput, HHCheckbox } from './fields';
import { FORM_NAME } from '../forms/formConstant';
import { signUp } from '../actions';

window.recaptchaOptions = {
  useRecaptchaNet: true
};

const formikEnhancer = withFormik({
  enableReinitialize: true,
  validationSchema: ({ translate, user }) => {
    const validationShape = {
      email: Yup.string()
        .email(translate('form.error.string.email'))
        .required(translate('form.error.mixed.required')),
      firstName: Yup.string()
        .strict(false)
        .trim()
        .max(30, translate('form.error.string.max'))
        .required(translate('form.error.mixed.required')),
      lastName: Yup.string()
        .strict(false)
        .trim()
        .max(30, translate('form.error.string.max'))
        .required(translate('form.error.mixed.required')),
      newsletterSubscription: Yup.boolean()
    };

    if (!user.hidePasswdFromSignup) {
      validationShape.newPassword = Yup.string()
        .min(8, translate('form.error.string.min'))
        .max(32, translate('form.error.string.max'))
        .required(translate('form.error.mixed.required'));
    }

    return Yup.object().shape(validationShape);
  },
  mapPropsToValues: ({ user }) => ({
    email: user.thirdPartyEmail || '',
    newPassword: '',
    firstName: user.thirdPartyFirstName || '',
    lastName: user.thirdPartyLastName || '',
    newsletterSubscription: false
  }),
  handleSubmit: (values, { props, setSubmitting }) => {
    if (values.newsletterSubscription) {
      props.onValidated({
        EMAIL: values.email
      });
    }

    const formData = { ...values };
    if (props.user.thirdPartyIdentification && props.user.thirdPartyFrom) {
      formData.thirdPartyType = props.user.thirdPartyFrom;
      formData.thirdPartyIdentification = props.user.thirdPartyIdentification;
    }

    props.signUp(formData).then(signUpFailed => {
      if (signUpFailed) setSubmitting(false);
    });
  },
  displayName: FORM_NAME.SIGNUP_FORM
});

const onChange = (value, values) => {
  values.captchaValue = value;
};

const SignupForm = props => {
  const {
    translate, isSubmitting, handleSubmit, user, values, activeLanguage
  } = props;

  return (
    <Form inverted onSubmit={handleSubmit}>
      <div className='signupFormTitle'>
        { translate('form.title.signupUser') }
      </div>
      <Form.Field>
        <Field
          name='email'
          component={HHInput}
          otherProps={{
            id: 'email',
            className: 'g-rounded',
            placeholder: translate('form.placeholder.email'),
            type: 'email'
          }}
        />
      </Form.Field>
      { !user.hidePasswdFromSignup && (
        <Form.Field>
          <Field
            name='newPassword'
            component={HHInput}
            otherProps={{
              id: 'newPassword',
              className: 'g-rounded',
              placeholder: translate('form.placeholder.password'),
              type: 'password'
            }}
          />
        </Form.Field>
      )}
      <div className='signupNameContainer'>
        <Form.Field >
          <Field
            name='firstName'
            component={HHInput}
            otherProps={{
              id: 'firstName',
              className: 'g-rounded',
              placeholder: translate('form.placeholder.firstName'),
              type: 'text'
            }}
          />
        </Form.Field>
        <Form.Field>
          <Field
            name='lastName'
            component={HHInput}
            otherProps={{
              id: 'lastName',
              className: 'g-rounded',
              placeholder: translate('form.placeholder.lastName'),
              type: 'text'
            }}
          />
        </Form.Field>
      </div>
      <Form.Field className='newsLetterSubscriptionField'>
        <Field
          name='newsletterSubscription'
          component={HHCheckbox}
          otherProps={{
            label: translate('form.label.newsletterSubscription')
          }}
        />
      </Form.Field>

      <div style={{ color: 'white', fontWeight: '400', margin: '20px auto' }}>
        {translate('form.label.agreeToTermOfUse')}
        <Link target='_blank' to='/signup_policy'>
          {translate('modal.title.termOfUseAndPrivacyPolicy')}
        </Link>
      </div>
      {
        activeLanguage &&
        <ReCAPTCHA
          sitekey='6Lfh4dEZAAAAACxqqEHzB0TTYMuhX7ybWCiKQ6Po'
          onChange={(e) => onChange(e, values)}
          hl={activeLanguage.code === 'zh-Hans' ? 'zh-CN' : 'en'}
          style={{ marginBottom: '20px' }}
        />
      }

      <Button
        primary
        fluid
        disabled={isSubmitting}
        loading={isSubmitting}
        className='g-rounded g-gradient heap-signup-button'
        type='submit'
        size='medium'
      >
        {translate('form.submitBtn.getStarted')}
      </Button>
    </Form>
  );
};

export default compose(
  withLocalize,
  connect(({ user }) => ({ user }), { signUp }),
  formikEnhancer
)(SignupForm);



// WEBPACK FOOTER //
// ./src/components/forms/signupForm.js